import { livFetch } from './client'
import type { NearbyPlacesResponse } from './types'

export async function getNearbyPlaces(
  apartmentId: number,
  radiusMeters: number
): Promise<NearbyPlacesResponse> {
  return livFetch<NearbyPlacesResponse>(
    `/places/${apartmentId}/nearby?radius_meters=${radiusMeters}`
  )
}
